import { createContext, useContext, type ReactNode } from "react";

type ActionsMenuContextValue = {
  onClose: () => void;
};

const ActionsMenuContext = createContext<ActionsMenuContextValue | null>(null);

/**
 * The enclosing menu's close handler, or `null` when there is no `ActionsMenu` ancestor. Must not
 * throw: `MenuItem` is also rendered inside plain `Popover` dropdowns (`campaigns-page`,
 * `program-templates-context-menu`), which own their open state and close themselves.
 */
export const useActionsMenuClose = (): (() => void) | null =>
  useContext(ActionsMenuContext)?.onClose ?? null;

type ActionsMenuProviderProps = {
  children: ReactNode;
  onClose: () => void;
};

export const ActionsMenuProvider = ({ children, onClose }: ActionsMenuProviderProps) => (
  <ActionsMenuContext.Provider value={{ onClose }}>{children}</ActionsMenuContext.Provider>
);
